import React, {Component} from 'react';
import {Avatar} from 'antd';
import {createHistory} from 'react-router'
import './style.scss';
import UserLogin from '@/components/UserLogin/index';
import SearchBar from '@/components/SearchBar/index';
import {get} from "lodash";
import {Menu, Row, Col} from 'antd';
import eventProxy from "react-eventproxy";
import {isUserLogin} from '@/utils/user';

const navMenus = [{
  displayName: "首页",
  link: '/',
  reg: /^/,
  cur: false
}, {
  displayName: '书库',
  link: '/classify',
  reg: /^\/classify/,
  cur: false
}, {
  displayName: '版权合作',
  link: '/copyright',
  reg: /^\/copyright/,
  cur: false
}, {
  displayName: '作家专区',
  link: '/author/person',
  reg: /^\/author/,
  cur: false
}];


export default class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchFocus: false,
      value: ''
    }
  }

  componentDidUpdate() {

  }

  componentDidMount() {
    var pathname = window.location.pathname;
    if (pathname === '/') {
      navMenus[0]['cur'] = true;
      return;
    }
    for (var i = 0; i < navMenus.length; i++) {
      if (navMenus[i]['reg'].test(pathname) && navMenus[i]['link'] !== '/') {
        navMenus[i]['cur'] = true;
      }
      else {
        navMenus[i]['cur'] = false;
      }
    }
  }

  inputOnFocus = () => {
    this.setState({
      searchFocus: true
    })
  }

  inputOnBlur = () => {
    this.setState({
      searchFocus: false
    })
  }

  onSearchChange = (e) => {
    console.log(e)
  }

  onLink = (url,e)=>{
    // 判断作者是否登录 by apia at 2021-10
    if (url !== '/' && url !== '/copyright' && url !== '/author/person' && url !== '/audiocopyright') {
      if (!isUserLogin()) {
        this.setState({
          isShowUserLoginModal: true
        })
        return;
      }
    }
    location.href=url
  }

  render() {
    const {searchFocus,isShowUserLoginModal} = this.state
    const {inputOnFocus, inputOnBlur, onSearchChange,onLink} = this

    return (
      <div className="topbar">
        <div className="main">
          <h1><a href="/">蜜阅书苑</a></h1>
          <ul className="topnav">
            {
              navMenus.map((navMenu,index) => {
                return <li className={navMenu.cur ? 'cur' : ''} key={index}><span onClick={onLink.bind(this,navMenu.link)}>{navMenu.displayName}</span></li>
              })
            }
          </ul>
          <div className="topsch" id="topsch">
            <SearchBar/>
          </div>
          <div className="user">
            <UserLogin isShowUserLoginModal={isShowUserLoginModal}/>
          </div>
        </div>
      </div>
    )
  }
}
